/**
 * Feature flags derivados de las variables de entorno de Vite.
 *
 * Vite inyecta toda variable `VITE_*` como STRING: con `VITE_DEMO_MODE=false` en el `.env`,
 * `import.meta.env.VITE_DEMO_MODE` vale `"false"`, que en JavaScript es truthy. Por eso la
 * comparación explícita contra `'true'` es la única lectura segura de estos flags — el mismo
 * patrón que ya usa `USE_MOCK` en `api/client.ts`.
 */

/** Paneles de QA (simulador de reuniones + log HTTP). Activos solo con `VITE_DEMO_MODE=true`. */
export const IS_DEMO_MODE = import.meta.env.VITE_DEMO_MODE === 'true';

/**
 * Herramientas de desarrollo local (simulador de perfil). Verdadero solo bajo `npm run dev`;
 * cualquier build compilado (QA o producción) las excluye, sin depender de variables de entorno.
 */
export const IS_DEV_BUILD = import.meta.env.DEV;

/**
 * Reglas de envío POR PROGRAMA (Fundamentales/Brillamos/Personalizada) — LIBERADO 2026-08-10 tras
 * terminar las pruebas: ENCENDIDO por defecto (el panel de reglas de Brillamos se muestra). Sigue siendo
 * un kill-switch: se apaga con `VITE_FEATURE_PROGRAM_RULES=false` (build) o
 * `localStorage.setItem('ff_program_rules','0')` (sin rebuild, en la consola).
 * El backend tiene su propio flag (`Recognition:ProgramRulesEnabled`), también ON por defecto.
 */
export function programRulesDevEnabled(): boolean {
  if (import.meta.env.VITE_FEATURE_PROGRAM_RULES === 'false') return false;
  try {
    return localStorage.getItem('ff_program_rules') !== '0';
  } catch {
    return true;
  }
}
